import { observer } from 'mobx-react-lite';
import React from 'react';
import { DriversTable } from '../components/driver/DriversTable';
import { employeesStore } from '../store/employeeStore/EmployeesStore';

export const DriversSettingsPage = observer(() => {
  const drivers = employeesStore.getEmployees();
  return <DriversTable drivers={[...drivers]} />;
});
